// App.js
import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';
import Home from './Home';
import About from './About';
import Gear from './Gear';
import Work from './Work';
import Contact from './Contact'; // We'll add a placeholder for this
import './App.css';

function App() {
  const [language, setLanguage] = useState('en'); // 'en' for English, 'pt' for Portuguese

  // Basic content structure for language switching
  // You'll need to fill this out with actual translations
  const content = {
    en: {
      navHome: "Home",
      navAbout: "About",
      navGear: "Gear",
      navWork: "Work",
      navContact: "Contact",
      aboutText1: "I’m an experienced location sound technician based in Lisbon, Portugal.",
      aboutText2: "I have been working with documentary, corporate, and narrative projects in the Boston area since graduating from film school in 2023. Whether it's a large set or a small passion project, I provide the same level of professional location sound production services.", // from PDF source [10]
      gearTitle: "Sound recording gear",
      gearItems: [ // from PDF source [8]
        "Zoom F8n Pro Mixer",
        "Lectrosonics Wireless",
        "Sanken Cos-11d Lavalier Mics",
        "Sennheiser MKH 50 and 416 Shotgun Microphones",
        "Tentacle Synch Timecode"
      ],
      workText: "I’ve worked with international sports leagues, non-profits, award winning independant films, and everything in between. If you have a project coming up, big or small, reach out to the email below and let's collaborate!" // from PDF source [3]
    },
    pt: {
      navHome: "Início",
      navAbout: "Sobre",
      navGear: "Equipamento",
      navWork: "Trabalhos",
      navContact: "Contato",
      aboutText1: "Eu sou um operador de som experiente, com base em Lisboa.",
      aboutText2: "Já trabalhei com projetos de documentário, corporativos e de ficção em Boston desde o final dos meus estudos na Prague Film School em 2023. Esteja numa produção grande ou num projeto de paixão mais pequeno, vou trazer igual nível de produção de som e profissionalismo.",
      gearTitle: "Equipamento de Captação de Som:",
      gearItems: [
        "Gravador Zoom F8n Pro",
        "Emisores da Lectrosonics",
        "Microfones de lapela Sanken Cos-11d",
        "Microfones Direccionais Sennheiser MKH 50 e 416",
        "Gerador de Timecode Tentacle Synch mk II"
      ],
      workText: "Trabalhei com ligas desportivas internacionais, ONGs, filmes independentes premiados, e muito mais. Se tiveres um projeto a caminho, grande ou pequeno, liga-me ou envia email abaixo e vamos colaborar!"
    }
  };

  const currentContent = content[language];

  useEffect(() => {
    // This is for smooth scrolling if you want to implement it later
    // For now, basic anchor links will work
  }, []);

  return (
    <div className="App">
      <Navbar
        language={language}
        setLanguage={setLanguage}
        content={currentContent}
      />
      <Home language={language} content={currentContent} />
      <About language={language} content={currentContent} />
      <div className="section-divider"></div>
      <Gear language={language} content={currentContent} />
      <div className="section-divider"></div>
      <Work language={language} content={currentContent} />
      <Contact language={language} content={currentContent} />
    </div>
  );
}

export default App;